<template>
  <md-button v-if="isVisible" :class="buttonClass" @click="add">
    <md-icon>add_box</md-icon>
    {{ text }}
  </md-button>
</template>

<script>
export default {
  name: "add-button",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    tooltip: {
      type: String,
      default: "Add"
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    role: {
      type: Number,
      default: undefined,
      validator: function(value) {
        return [100].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    isVisible() {
      if (!this.$auth.isInGlobalRole()) {
        if (!this.$auth.isInRole(this.role)) return false;
        else return this.visible;
      } else return this.visible;
    },
    buttonClass() {
      return !this.isSmall ? "md-primary add-button md-sm" : "md-primary md-sm";
    }
  },
  methods: {
    add() {
      this.$emit("add-click");
    }
  }
};
</script>

<style>
.add-button {
  float: right;
  margin-top: 10px !important;
}
</style>
